import { render, staticRenderFns } from "./ResultScreen.vue?vue&type=template&id=425a1ca2"
import script from "./ResultScreen.vue?vue&type=script&lang=js"
export * from "./ResultScreen.vue?vue&type=script&lang=js"
import style0 from "./ResultScreen.vue?vue&type=style&index=0&id=425a1ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports